// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__9obBI","title":"ClientReferral_title__cihV5","itemText":"ClientReferral_itemText__1PDqu"};